var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "url(#pattern0_247_947)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_247_947",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_247_947",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_247_947",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEtElEQVR4nO2cTYwUVRDHW7JwAOHKx4WPhQDigWAi4gEFDxg+FC8KMSGejEE+EtYEFA7eXNeTYiIgHAkH0XgxIIpR0BAwxBOIiXxoUAku6rJsYAnuz1T2kazDVM8wU697uqd+yVx6e6vq1b+7X/d79V6SOI7jOI7jOI7jtADAKGAFcBD4GRjk/hkM//sRsFxs5t2uQgBMBb7BnhPAzLzb19IAs4Be4vGni6AnfwLwE/ERHxOyvbQKALCX7Pgw7/a2FMBTwBDZ8nTe7W6lR88vSpJElK3A+Absjge2pQgrPtv7UQRMA47EfFSIjRT74ntaUjSAJcAe4EfgBnH41eIKDXeY2IrBjZCD3cCTNtlNb0wncJT4DAHLDONellEf8wUw3SruykY8HvkdfSQ7I8S/k2yQb41FMa78rJL/GdBh2oDhNnQAhzIUwe5OAL7MIOgh4F1gjFng97ZjNPAmcCeD9nxlFfTSiEH+DfwA9ACzTQKur01zgHeCb4khFs13zOFtpxq3gC3A5KRNASYDXSEX1dhl4eScYrzLpBUlAHhNydFZC+P9ivFJJtGXAMmFkqPrFsarYhJ5iYiWJxegPlyAnHEBjJHvEeBt4HfgN6A77RvFBTAmJLyS7pTzvQ+wJFz5lfyRcr4LYEl47FRyuW0FAGYArwIHwhDCNeB2+F0Lx+Rv6+XcSI+gt9pKAOAB4Bng2H2O5w+F2qJVYqOJTrg73Ant1wkDDwHf0TzfAnMziLc8AgBrgQHsuAm8FDnmcggAbCIO8ljaFDHu4gsArIk8dyu2n48Ue5w8RTNcvS50oEYCz4ev0yXhrWhc+M0Ix3rCObUqGTojxF94AY6mJO0fYEM9c8Vh7ncj0Jdi70iE+IsrALAwJVlXgPkN2JynfEzdxbRyoegCfKq4kam+BU3YXZCyuOMT4zYUUwCG51X/Vdy8bmB/u2JbfE60aUWxBXhRcSHDCw8a2B+XUtO0xqYVxRZgn+LivQyq4szWCRRZgO8VF88a+lit+Dhl6KOwAlxSXJiVjUuZoOLjoqGPwgowoLgYa+hjrOJjwNCHC6AhnbmSn/7EiCILcElx4Y+gnDvh1YY+nlN8nDT0Udg7YG/sRRrA+4qPPYY+Svch9lcjqyOV1ZJaCbp/iDFc2KoNRbxhIMAOxbYPRdQxGDfY5GDcIymDcR83alfxVZXWNfx/H49GGI5+uMZw9GPGbSiuAEJY4qnRF+aKO+pcB7a5xoTM4cSYMggws45F3xfCtOPSsHLz7pRkZzjWE85Jo9+icKt0AgjACz4pn6MAAvByJBHE5sYkEqURYER5inVh1rokIqUSQJByQuC4QfKlrnROEpnSCTCiOFcKbL9uoDhX/mdlkhGlFKDK3kKvAPuB02GedzD8esOx/eGczPcAKr0ArY4LkDMuQM64ADnjAuSMC5AzLkCJBbiu2G7bjZoqAaYoOepLmsU3bMp/wybZlFSr3e9q5zuB2luWfWDhRNZeOY2x2ErptP2dndjTnmEg7KriyLmXXvNpT1nUFnaEddK5al1xUVln748jnc8zGQoHnpBNSeU1K2Vby3agHzgjbztmHa7jOI7jOI7jOI7jOI7jOI7jOEnZ+A+cxVw0K3nynAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera_icon.91cb6a40d58587a0231497b2a03257e5.svg";
export { ForwardRef as ReactComponent };